// src/App.js
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css'
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import Home from './pages/Home'
import About from './pages/About'
import CardDetail from './pages/CardDetail'
import ScrollToTop from './components/ScrollToTop';

const App = () => (
 
    <Router>
        <Header />
        <Routes>
        <Route
          path="/"
          element={
            <>
              <ScrollToTop />
              <Home />
            </>
          }
        />
        <Route
          path="/about"
          element={
            <>
              <ScrollToTop />
              <About />
            </>
          }
        />
        <Route 
            path="/post/:id" 
            element={
            <>
            <ScrollToTop />
            <CardDetail />
            </>} 
        />
        </Routes>
        <Footer />
    </Router>
);

export default App;
